import { ImageSourcePropType } from 'react-native';
import { Variant } from '@features/company/types/variant';

// Images
import imgV1 from 'src/assets/dotScreenBanner/dotBanner.png';
import imgV2 from 'src/assets/dotScreenBanner/moneyJar.png';
import imgV45 from 'src/assets/dotScreenBanner/moneyHand.png';
import imgV6 from 'src/assets/dotScreenBanner/moneyNotes.png';

export const VARIANT_UI: Record<
  Variant,
  { title: string; button: string; image: ImageSourcePropType; showBullets: boolean }
> = {
  v1: {
    title: 'Share Your DOT to Get Started\nWith an Agent Today',
    button: 'Next',
    image: imgV1,
    showBullets: true,
  },
  v2: {
    title: 'See How Much $$$ You’ll Save with Trucker Path Insurance!',
    button: 'Show Me My Savings',
    image: imgV2,
    showBullets: false,
  },
  v4v5: {
    title: 'Are You Overpaying for Your Insurance? Enter Your DOT Number to Find Out!',
    button: 'Check My Rates',
    image: imgV45,
    showBullets: false,
  },
  v5: {
    title: 'Are You Overpaying for Your Insurance? Enter Your DOT Number to Find Out!',
    button: 'Check My Rates',
    image: imgV45, // same as v4v5
    showBullets: false,
  },
  v6: {
    title: 'Get a Hassle-Free Quote in Under 5 Minutes from TPI!',
    button: 'Get a Quote',
    image: imgV6,
    showBullets: false,
  },
};
